// src/slices/shipessitional/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getShipTrafficAll = createAsyncThunk("shipTrafficAll/getAll", async (params = {}, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/ship-traffic/all`, { params: { ...(params.page && { page: params.page }), ...(params.search && { search: params.search }), ...(params.unloadingPort && { unloadingPort: params.unloadingPort }) } });

    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});
